export const stripeAppearance = {
  theme: 'stripe',
  variables: {
    spacingUnit: '6px',
  },
  rules: {
    '.Label': {
      color: '#8C8C8C',
      fontSize: '12px',
    },
    '.Input': {
      color: '#020529',
      fontSize: '15px',
      padding: '13px',
    },
  },
};